/** Unique ids and names for new elements and fields. */

/** `prefix` + the smallest number ≥ 1 not in `taken` (e.g. text1, text2). */
export function uniqueId(prefix: string, taken: ReadonlySet<string>): string {
  const base = prefix.replace(/[^A-Za-z0-9_-]/g, '') || 'el';
  const start = /^[A-Za-z]/.test(base) ? base : `el${base}`;
  for (let n = 1; ; n++) {
    const id = `${start}${n}`;
    if (!taken.has(id)) return id;
  }
}

/** A field id (identifier) from a title: "Name" → name, "Job title" → jobTitle, "Ääni" → aani. */
export function fieldIdFrom(title: string, taken: ReadonlySet<string>): string {
  const words = title
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean);
  let id = words.map((w, i) => (i === 0 ? w.toLowerCase() : w[0]!.toUpperCase() + w.slice(1).toLowerCase())).join('');
  if (!/^[A-Za-z_]/.test(id)) id = `field${id}`;
  id = id.slice(0, 60);
  if (!taken.has(id)) return id;
  for (let n = 2; ; n++) if (!taken.has(`${id}${n}`)) return `${id}${n}`;
}

export const FIELD_ID = /^[A-Za-z_][A-Za-z0-9_]{0,63}$/;
